import { Action } from 'redux'

import { SET_PAYMENT_METHOD_ERROR, SET_PAYMENT_METHOD_SUCCESS, SET_PAYMENT_METHOD_REQUEST } from '../constants/ActionTypes'

export default function paymentMethodError(state = {}, action: Action) {
    switch (action.type) {
        case SET_PAYMENT_METHOD_ERROR:
            return true
        case SET_PAYMENT_METHOD_REQUEST:
        case SET_PAYMENT_METHOD_SUCCESS:
            return false
        default:
            return state
    }
}
